module.exports = __webpack_public_path__ + "img/apple.03c60423.svg";